import React from "react";
import PropTypes from "prop-types";

import styled from "styled-components";
import { CFontIcon, Text, CIconButton } from "@appcues/component-library";
import { getThemeFor } from "utils";

const BannerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 2px 10px;
  max-width: 600px;
  margin-bottom: 10px;
  background-color: ${getThemeFor("$red-med")};
  border-radius: 8px;
  div .svg-inline--fa {
    color: ${getThemeFor("$red")};
  }
  div span {
    margin-left: 10px;
  }
  .icon-button {
    background-color: ${getThemeFor("$red-med")};
  }
`;

const DismissibleBanner = ({
  onClose,
  text,
  iconClassName = "fa fa-time",
  className
}) => {
  return (
    <BannerContainer className={`dismissible-banner ${className}`} role="alert">
      <div>
        <CFontIcon altText={iconClassName} className={iconClassName} />
        <Text bold>{text}</Text>
      </div>
      <CIconButton role="button" border="none" onClick={onClose}>
        <CFontIcon altText="close" className="fa fa-times" />
      </CIconButton>
    </BannerContainer>
  );
};

DismissibleBanner.propTypes = {
  onClose: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  iconClassName: PropTypes.string,
  className: PropTypes.string
};

export default DismissibleBanner;
